import type { SVGProps } from "react";
import * as React from "react";
const SvgLinear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M2.245 14.305c-.044-.19.182-.31.32-.172l7.302 7.303c.138.137.018.363-.172.319a10.025 10.025 0 0 1-7.45-7.45ZM2 11.378a.198.198 0 0 0 .058.152L12.47 21.942c.04.04.095.061.152.058.474-.03.939-.092 1.393-.186a.194.194 0 0 0 .095-.33L2.515 9.89a.194.194 0 0 0-.33.095c-.093.454-.155.919-.185 1.393Zm.842-3.437a.198.198 0 0 0 .042.22l12.955 12.955a.198.198 0 0 0 .22.042c.357-.16.703-.339 1.037-.537a.196.196 0 0 0 .037-.308L3.687 6.867a.196.196 0 0 0-.308.037 9.98 9.98 0 0 0-.537 1.037Zm1.69-2.326a.197.197 0 0 1-.01-.271A9.985 9.985 0 0 1 11.99 2C17.518 2 22 6.481 22 12.01a9.985 9.985 0 0 1-3.344 7.467.197.197 0 0 1-.27-.009L4.531 5.615Z"
    />
  </svg>
);
export default SvgLinear;
